import { ReactNode } from "react";

import { hands, smart } from "@smart/bridge-images-dom";
import { aboutUs, displayName } from "@smart/itops-utils-basic";

type LoginProps = {
  children: ReactNode;
};

const Login = ({ children }: LoginProps) => (
  <div className="flex h-[100vh]">
    <div className="flex flex-col flex-1 max-w-[40rem] p-[2rem] gap-large">
      <div className="flex items-center gap-large">
        <div
          className="w-[5rem] h-[5rem] bg-cover bg-center"
          style={{ backgroundImage: `url(${smart})` }}
        />
        <h1 className="text-h3">Welcome to {displayName}</h1>
      </div>

      <div className="flex-1">
        <p className="text-ui">{aboutUs}</p>
        {children}
      </div>
      <div>
        <small>
          Privacy and security are important to us. Your personal details and
          data shared will be kept securely and not shared. Read our privacy
          statement.
        </small>
      </div>
    </div>

    <div
      className="bg-cover bg-center flex-1"
      style={{ backgroundImage: `url(${hands})` }}
    />
  </div>
);

export { Login, LoginProps };
